import { get } from 'lodash'

import { Colors, DateFields } from '@sigma-frontend-libs/commons'

import { getLocaleDateString, getLocaleTimeString, icons, isEmpty } from '@/utils'

import render from './render'

export default {
  name: 'Date',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    label: String,

    field: {
      type: String,
      default: DateFields.createdAt
    },

    compact: {
      type: Boolean,
      default: true
    },
    icon: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    baseProps() {
      const rawValue = get(this.value, this.field)
      const label = this.label || this.getTranslate(`filter.date.labels.single.${this.field}`)
      const noData = '---'

      const result = {
        value: noData,
        label,
        tooltip: [ label, noData ].join(' ')
      }

      if (!isEmpty(rawValue)) {
        const dateString = getLocaleDateString(rawValue)
        const timeString = getLocaleTimeString(rawValue)

        result.value = [ dateString, timeString ].join(' ')
        result.tooltip = [ label, timeString, dateString ].join(' ')

        if (this.compact) {
          result.value = timeString
          result.label = dateString
        }
      }

      return result
    },

    iconProps() {
      const result = {}
      if (this.icon) {
        result.icon = icons.date_range
        result.color = Colors.grey
        result.iconTooltip = this.baseProps.tooltip

        if (this.field === DateFields.expiredAt) {
          result.icon = icons.event_busy
        }
      }

      return result
    },

    sizeProps() {
      const result = {
        minWidth: 170
      }
      if (this.icon && this.compact) {
        result.minWidth = 105
        result.width = 105
      } else if (this.compact) {
        result.minWidth = 75
        result.width = 75
      }

      return result
    },

    $_props() {
      return {
        ...this.baseProps,
        ...this.iconProps,
        ...this.sizeProps
      }
    }
  },

  render
}
